/*=========================================================================================
  File Name: mutations.js
  Namespace: reporting
  Description: Vuex Store - Reporting mutations
==========================================================================================*/

const mutations = {
  STORE_RATING_REPORTS(state, reportings) {
    state.reportingList = {
      ...state.reportingList,
      ...reportings.entries
    }
    state.count = reportings.count
    state.next = reportings.next
    state.previous = reportings.previous
    state.results = [...reportings.results]
  },
  STORE_REPORT_TO_LIST(state, reporting) {
    state.reportingList = {
      ...state.reportingList,
      ...reporting
    }
  },
  
}

export default mutations

